import type { FactCheckDesktopV3Attributes } from '@/features/fact-check-desktop-v3/fact-check-desktop-v3-type';

import KeyFactsDesktop from '@/core/components/key-facts/key-facts-desktop';
import SeasonCalendar from '@/features/season-calendar/season-calendar';
import SpotScoreBadgeDesktop from '@/features/spot-score/spot-score-badge-desktop';

export default function FactCheckDesktopV3({
    keyFacts,
    seasonCalendar,
    spotScore,
    title,
}: FactCheckDesktopV3Attributes) {
    return (
        <div className={'gap content-box-border'}>
            <div>
                {title && <div className={'margin-bottom-10 font-size-18 bold'}>{title}</div>}
                <SpotScoreBadgeDesktop
                    flip={false}
                    fontWeight={'bold'}
                    placement={'bottom-start'}
                    qaId={'qa-fact-check-spot-score-desktop'}
                    scoreMarginBottom={6}
                    spotScore={spotScore}
                    type={'horizontalReverse'}
                />
                <SeasonCalendar
                    rowCount={2}
                    seasonCalendar={seasonCalendar.seasonCalendar}
                    title={seasonCalendar.title}
                    titleFontSize={'font-size-14'}
                    titleMarginBottom={10}
                />
            </div>
            <KeyFactsDesktop
                fontSize={'font-size-14'}
                gap={10}
                iconSize={16}
                keyFacts={keyFacts}
            />
        </div>
    );
}
